import apiClient from './client';

/**
 * Sequence Management API
 * Centralized sequence number generation for all modules
 */

export const sequenceAPI = {
    /**
     * Get all sequence settings (all modules)
     */
    getAllSettings: async (): Promise<any> => {
        const response = await apiClient.get('/sequence/settings');
        return response.data;
    },

    /**
     * Get sequence settings for specific module
     */
    getModuleSettings: async (module: string): Promise<any> => {
        const response = await apiClient.get(`/sequence/settings/${module}`);
        return response.data;
    },

    /**
     * Update sequence settings for a module
     */
    updateSettings: async (module: string, settings: any): Promise<any> => {
        const response = await apiClient.put(`/sequence/settings/${module}`, settings);
        return response.data;
    },

    /**
     * Generate next sequence (for testing)
     */
    generateNext: async (module: string): Promise<any> => {
        const response = await apiClient.post(`/sequence/generate/${module}`);
        return response.data;
    },
};

export default sequenceAPI;
